import { render, staticRenderFns } from "./AiReviewActions.vue?vue&type=template&id=5a14c654"
import script from "./AiReviewActions.vue?vue&type=script&lang=js"
export * from "./AiReviewActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports